import orderBy from "lodash/orderBy";
import { observable, makeObservable } from "mobx";
import { DateTime } from "luxon";
import { getAlarms } from "../../Monitor/MonitorUtils";
import config from "../../../config";
import { hasWaveData } from "../../Monitor/MonitorStore";

export default class SurveilPatientStore {
  config;
  highestAlarm = {};
  discretesRow = [];
  bookmark = {};
  _measurements;

  constructor() {
    makeObservable(this, {
      config: observable,
      highestAlarm: observable,
      discretesRow: observable,
      bookmark: observable,
    });
  }

  totalBufferLength = Math.ceil(
    config.pm.surveilLeadBufferSeconds * 2 + config.pm.mpv.singleLeadSeconds,
  );

  updateValues({ discretesRow }) {
    this.discretesRow = orderBy(
      discretesRow,
      ["isLocked", "locked"],
      ["desc", "desc"],
    );
  }

  set measurements(measurements) {
    const newData = measurements.data.map((segment) => {
      return {
        ...segment,
        dateTime: DateTime.fromISO(segment.timestamp),
      };
    });
    const serverTime = DateTime.fromISO(newData.lastItem?.dateTime);
    if (serverTime?.isValid && hasWaveData(measurements)) {
      this.updateLatency(DateTime.local().diff(serverTime));
    }
    const minTime = serverTime.minus({ seconds: this.totalBufferLength });
    if (!this._measurements?.data || measurements.reset)
      this._measurements = measurements;
    else {
      this._measurements = {
        ...measurements,
        data: [...this._measurements.data, ...newData].filter(
          (segment) => segment.dateTime >= minTime,
        ),
      };
    }
  }

  get measurements() {
    return this._measurements;
  }

  get measurementData() {
    return this.measurements?.data || [];
  }

  updateAlarm() {
    const bufferSeconds = Math.floor(config.pm.surveilLeadBufferSeconds);
    const chartLength = Math.ceil(config.pm.mpv.singleLeadSeconds);
    const slicedMeasurements =
      this.measurements?.data?.slice(
        -chartLength - bufferSeconds,
        -bufferSeconds,
      ) || [];
    this.highestAlarm =
      getAlarms(slicedMeasurements, { highestOnly: true })[0] || {};
  }

  get waveGroup() {
    if (this.config?.waveGroups?.length) return this.config?.waveGroups[0];
    else return undefined;
  }

  updateLatency(newLatency) {
    if (!this.serverLatency) return (this.serverLatency = newLatency);
    if (
      Math.abs(newLatency - this.serverLatency) >
      config.pm.surveilLeadBufferSeconds * 1000
    ) {
      this.serverLatency = newLatency;
    }
  }
  get serverTime() {
    return !isNaN(this.serverLatency)
      ? DateTime.utc().minus(this.serverLatency)
      : null;
  }
}
